
const ordenesdeproteccion = {
    AltaOrdendeProteccion: 'REGOP/Administracion/OrdenesDeProteccion/AltaOrdendeProteccion',
    BuscarOrdendeProteccion: 'REGOP/Consultas/OrdenesDeProteccion/BuscarOrdendeProteccion'
}

const administracion = {
    ordenesdeproteccion: ordenesdeproteccion
}

export default administracion;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/REGOP/Sistema/Administracion/administracion.js
// module id = null
// module chunks = 